import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";

type Props = {
  onActionDeletar: ( Id: number | null, openState: boolean) => void,
};

export const GenerateQualidadeItemProcessosIndicadorColumns = ({onActionDeletar}: Props): GridColDef[] => {
 return [
    {
      field: "Item", 
      filterable: false,
      headerName: "Item", 
      width: 80,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Descricao",
      filterable: false,
      headerName: "Indicador",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex items-center text-left whitespace-normal break-words py-2 line-clamp-3">
          <span>{params.value}</span>
        </div>
      )
    },
    {
      field: "Indice",
      filterable: false,
      headerName: "Índice",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex items-center text-left whitespace-normal break-words py-2">
          <span>{params.value}</span>
        </div>
      )
    },
    {
      field: "Frequencia",
      filterable: false,
      headerName: "Frequência",
      width: 120, 
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Meta",
      filterable: false,
      headerName: "Meta",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex items-center text-left whitespace-normal break-words py-2">
          <span>{params.value}</span>
        </div>
      )
    },
    {
      field: 'IdItemProcessoIndicador',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 80, 
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-1">
            <IconButton onClick={() => onActionDeletar(params.value, true)} >
              <DynamicIcon nameIcon="DeleteForeverRounded" size={22} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}